
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css' //ele组件相关CSS
import 'splitpanes/dist/splitpanes.css'
import App from './App'
import router from './router'
import http from './utils/http';
import elementUI from 'element-ui'  //ele页面组件
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import dayjs from 'dayjs' //日期时间处理组件
import 'dayjs/locale/zh-cn'
import calendar from 'dayjs/plugin/calendar'
import updateLocale from 'dayjs/plugin/updateLocale'
import './assets/el.css' //elcss
import store from './store';
import { message } from './utils/msg'
import fmt from './utils/fmt'
import baseData from './utils/baseData'

import { Splitpanes, Pane } from 'splitpanes'
import './assets/iconfont.css' //elcss

import sysApi from './api/sys.api'
import app from './store/modules/app';
Vue.component('Splitpanes', Splitpanes)
Vue.component('Pane',Pane)

dayjs.extend(calendar);
dayjs.extend(updateLocale);
dayjs.locale('zh-cn')
dayjs.updateLocale('zh-cn', { calendar: 
    { lastDay: '昨天HH:mm', sameDay: '今天HH:mm', nextDay: '明天HH:mm', lastWeek: '上周', nextWeek: '下周', sameElse:'YYYY/MM/DD' } 
})

/*
VXETable.Modal.props.events.show =  {
    type: Function,
    default: () => {console.log('coluddddddddmn >>>');}
};
*/
VXETable.setup({ size: 'mini' })
Vue.use(VXETable)
Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.prototype.$api ={
  sysApi:sysApi,
} 
elementUI.Tooltip.props.effect = { type: String, default: 'light' };
elementUI.Tooltip.props.openDelay = { type: Number, default: 400 };

Vue.use(elementUI, { size: "mini" })
Vue.prototype.$message = message; //需要放在Vue.use(elementUI, {size:"mini"})之后。
Vue.prototype.$modal = VXETable.modal;
Vue.prototype.$fmt = fmt;
Vue.prototype.$baseData = baseData;
Vue.filter('fmtvalue', fmt.autoFormat);
Vue.filter('dateFormat', fmt.dateFormat);
Vue.prototype.$ConvertObj = fmt.convertObj;
Vue.prototype.$removeSameObj = fmt.removeSameObj;


// 不loading (_config):{headers: {'showLoading': false}}
// 指定目标loading  (_config)：{headers: {'loadingTarget': '#dialogContent'}}  
Vue.prototype.$Post = (data, _config) => {
    if (data.apiID != 'FF98C611-0BDD-4EB3-A716-5554A274840E' && !baseData.vue_user) { //非登录请求。
        vm.$router.push('/login');
        return;
    }
    data.pageSize = data.pageSize || 10000;  //一次从后台获取最多20000条，前端分页
    data.pageNo = data.pageNo || 1;    //目前最多取pageSize条数据
    return http.post((_config && _config.url)||sys.apiUrl, data, _config)
}
// Vue.prototype.$BulkPost = (data, _config) => {
//     if ( !baseData.vue_user) { //非登录请求。
//         vm.$router.push('/login');
//         return;
//     }
//     data.pageSize = data.pageSize || 10000;  //一次从后台获取最多20000条，前端分页
//     data.pageNo = data.pageNo || 1;    //目前最多取pageSize条数据
//     return http.post((_config && _config.url)||sys.bulkApiUrl, data, _config)
// }
router.beforeEach((to, from, next) => {
    (to.path == "/" || to.path == "/login" || baseData.vue_user) ? next() : next({ path: '/login' });
})
var vm = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
})


// WEBPACK FOOTER //
// ./src/main.js